import { ephemeralStore } from "../runtime/ephemeralStore";
import type { RouteHistory } from "../types";
import { routeHistorySlice } from "./routeHistory.slice";

/**
 * Appends a route to the session car history.
 *
 * @param route Calculated route entry to store.
 */
export const appendRouteHistory = ( route: RouteHistory ): void => {
    ephemeralStore.setValue( routeHistorySlice, ( previous ) => [ ...previous, route ] );
};

/**
 * Clears all entries from the session car route history.
 */
export const clearRouteHistory = (): void => {
    ephemeralStore.setValue( routeHistorySlice, [] );
};
